<template>

  <svg
    t="1632727459903"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="7203"
    width="64"
    height="64"
  ><path d="M933.8752 589.12533332c0 93.19146667-75.5584 168.74986667-168.74986667 168.74986667h-506.25066666c-93.19146667 0-168.74986667-75.5584-168.74986667-168.74986667V351.99999999c0-93.19253333 75.5584-168.74986667 168.74986667-168.74986667h506.25066666c93.19146667 0 168.74986667 75.55733333 168.74986667 168.74986667v237.12533333z" p-id="7204" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconShapeRoundRect',
} as DefineComponent
</script>